import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { detect } from "detect-browser";
import { getAdminDetailsThunk } from "USERPROFILE/supportSlice";
import {
  getClientThunk,
  getIacRejectToLogin,
  postLoginThunk,
  postLoginThunkUpdated,
  postSsoLoginThunk,
  setCompanyNumber,
  setCurrentRoute,
  setSsoErrorMessage,
  setSsoErrorMessageFunc,
  setSsoLoginUser,
  logUserDetails,
} from "../../redux/features/loginSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import useIdentifySsoClient from "../../SSOClientsData/useIdentifySsoClient";
import { CLIENT_SETUP_IAC } from "../../ClientSetupIac";

function SSOLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enableIACCheckonLogin } = CLIENT_SETUP_IAC;
  const { companyNumber } = useSelector((state) => state.login);
  const { adminData } = useSelector((state) => state.support);

  const [searchParams, setSearchparams] = useSearchParams();
  const [cookies, setCookie] = useCookies();
  const login = useSelector((state) => state.login);
  const { currentPrivilege = [] } = login;
  const [ssoLoginStatus, setSsoLoginStatus] = useState(
    searchParams.get("userLoginClicked")
  );
  const [ssoLoginToken, setSsoLoginToken] = useState(
    searchParams.get("jwtToken") || ""
  );
  const [ssoErrorMessage, setSsoErrorMessage] = useState(
    searchParams.get("errormsg") || ""
  );

  const clientData = useIdentifySsoClient(companyNumber);

  function captureUserDetails(userInfo = {}) {
    const browser = detect();
    const appId = process.env.REACT_APP_APP_ID;
    let companyNumber = login.companyNumber;

    const {
      appCodeName,
      appName,
      appVersion,
      connection: { downlink, effectiveType } = {},
      deviceMemory,
      hardwareConcurrency,
      language,
      product,
      productSub,
      userAgent,
      userAgentData: { brands = [], mobile, platform } = {},
    } = navigator;

    //#region saved user agent logs
    const errorDetailPayload = {
      errorDetailPage: "ssoLogin",
      errorDetailUrl: "",
      errorDetailPayload: {
        browser,
        userAgent,
        platform,
        appVersion,
        appName,
        companyNumber,
        appId,
        appCodeName,
        downlink,
        effectiveType,
        deviceMemory,
        hardwareConcurrency,
        language,
        product,
        productSub,
        brands,
        mobile,
        ...userInfo,
      },
      errorDetailResponse: "",
      userName: login?.decodedTokenObject?.userName,
      companyNumber: companyNumber,
      recordType: "Info",
      errorType: "Info",
    };

    dispatch(logUserDetails(errorDetailPayload));
    //#endregion saved user agent logs
  }

  useEffect(() => {
    dispatch(getClientThunk());
    setSsoLoginStatus(searchParams.get("userLoginClicked"));
    setSsoLoginToken(searchParams.get("jwtToken"));
    setSsoErrorMessage(searchParams.get("errormsg"));
  }, []);

  useEffect(() => {
    if (ssoLoginStatus == "true" && ssoLoginToken) {
      dispatch(setSsoLoginUser(true));
      let companyNumber = login.companyNumber;
      dispatch(setCompanyNumber(companyNumber));

      dispatch(
        postLoginThunkUpdated({
          status: "success",
          responseBody: ssoLoginToken,
          errorMessage: ssoErrorMessage,
        })
      ).then((response) => {
        const iacPayload = {
          iac: response?.payload?.userInfo?.userInfo?.userAttributes?.iac,
          userInfo: response?.payload?.userInfo?.userInfo,
        };
        captureUserDetails(iacPayload);
        if (enableIACCheckonLogin?.includes(companyNumber)) {
          dispatch(getIacRejectToLogin(iacPayload));
        }
      });
    } else if (
      (ssoLoginStatus == "true" && ssoErrorMessage) ||
      !ssoLoginToken
    ) {
      dispatch(setSsoErrorMessageFunc(ssoErrorMessage));
      navigate("/login-error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyNumber]);

  useEffect(() => {
    const { headerLinks: { orderSearch = {} } = {} } = adminData;
    const isAccessToOrderSearch =
      orderSearch?.fieldVisible == "true" &&
      orderSearch?.fieldKey &&
      currentPrivilege.includes("Order Search")
        ? true
        : false;

    const navigateTo =
      sessionStorage.getItem("preselect") == "true" ||
      (sessionStorage.getItem("isOrderDetailDirectLink") == "true" &&
        !isAccessToOrderSearch)
        ? "/searchResults"
        : isAccessToOrderSearch &&
          sessionStorage.getItem("isOrderDetailDirectLink") == "true"
        ? `/orderDetailData/${+sessionStorage.getItem("orderNumber")}`
        : "/home";

    let iacCheck =
      login.userInfoAttr?.userInfo?.companyNumber == "0831"
        ? login?.isActiveIacUser
        : true;

    if (ssoLoginStatus == "true" && !ssoErrorMessage) {
      dispatch(setSsoLoginUser(true));
      if (iacCheck === false) {
        navigate("/login-error");
      } else if (
        login.apiStatusCode &&
        login.apiStatusCode === 200 &&
        iacCheck
      ) {
        dispatch(getAdminDetailsThunk());
        if (login.currentRoute) {
          // navigate(login.currentRoute);
          navigate(navigateTo);
        } else {
          navigate(navigateTo);
        }
        setCookie("token", login.data, {
          path: "*",
          expires: new Date(Date.now() + 300000000),
        });
      }
    }
  }, [login, login?.isActiveIacUser]);

  useEffect(() => {
    const envs = ["qa", "uat", "localhost", "dev"];
    const prodSsoLoginByEnv = envs.every(
      (e) => !window.location.host.includes(e)
    );
    if (login.data && login.data.status < 500 && login.data.status > 399) {
      if (prodSsoLoginByEnv) {
        window.location.replace(clientData?.ssoProdUrl);
      } else {
        window.location.replace(clientData?.ssoUatUrl);
      }
    }
  }, [login]);

  useEffect(() => {
    if (ssoErrorMessage) {
      dispatch(setSsoErrorMessageFunc(ssoErrorMessage));
      navigate("/login-error");
    }
  }, [login]);

  return (
    <div className="loading-box" style={{ backgroundColor: "#ffffff" }}>
      <div className="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div className="loading lds-roller">Loading...</div>
    </div>
  );
}

export default SSOLogin;
